<template>
    <LayoutDefault
        variant="black"
    >
        <div class="bg-white mt-56 md:mt-80 mb-20">
            <OrganismProject />
        </div>
    </LayoutDefault>
</template>

<script>
import LayoutDefault from "../layouts/LayoutDefault.vue";
import OrganismProject from "../components/project/organisms/OrganismProject.vue";

export default {
    name: 'PageProjects',
    components: {
        OrganismProject,
        LayoutDefault
    }
}
</script>
